import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Injectable()
export class ProductEditForm {
    constructor(private formBuilder: FormBuilder) {}

    public buildForm(): FormGroup {
        return this.formBuilder.group({
            campaignUuid: [null, [Validators.required]],
            name: [''],
            externalId: [null],
            category: ['', [Validators.required]],
            subcategory: [null],
            products: [[]],
        });
    }
}
